// PLQA-C-005: the pricing card and the Confirm-Upgrade/Downgrade modal used
// to derive a plan's "billed annually" total two different ways -- the card
// computed `Math.round(monthlyPrice * 12)` while the modal defaulted to a
// separately server-sourced annual figure. For the same tier those two
// numbers can legitimately disagree (e.g. 6.88 * 12 = 82.56, rounded to 83
// by the card vs a stored 82.5 on the modal side). Both surfaces now call
// this single helper so the same plan always shows the same annual total.
export const formatAnnualTotal = (monthlyPrice) => {
  const value = parseFloat(monthlyPrice) || 0;
  return (value * 12).toFixed(2);
};

// ISP-9999: the temporary 50%-off annual promo (Gordon's ruling: applied
// automatically server-side -- never a user-entered coupon, see
// CouponDisplay) is meant to apply uniformly across every paid annual tier.
// Premium/ProSuite come back from `/subscription/packages/` with a distinct
// `orig_per_month_cost`, but Essential's response duplicates `per_month_cost`
// into `orig_per_month_cost` -- so a naive equality check between the two
// sees no discount and the struck-through original silently disappears on
// exactly the tier where a price-sensitive shopper is most likely to look.
// The rate itself is fixed and already public-facing (CouponDisplay's banner
// copy), so deriving the implied original from it is a safe fallback for
// exactly this gap -- it never overrides a real, distinct orig_per_month_cost
// the API already provides.
export const ANNUAL_DISCOUNT_RATE = 0.5;

export const resolveDisplayedOriginalPrice = (perMonthCost, origPerMonthCost) => {
  const per = parseFloat(perMonthCost) || 0;
  const orig = parseFloat(origPerMonthCost);
  if (Number.isFinite(orig) && orig !== per) return origPerMonthCost;
  if (!per) return origPerMonthCost;
  return (per / (1 - ANNUAL_DISCOUNT_RATE)).toFixed(2);
};
